import { ConnectorsHubPage } from '@/features/connectors';

export default function ConnectorsRoute() {
  return <ConnectorsHubPage />;
}
